"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Button_1 = __importStar(require("../Button"));

var Burger_1 = __importDefault(require("./Burger"));

var Profile_1 = __importDefault(require("./Profile"));

var config_1 = require("../config");

var Header =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header(props) {
    var _this = _super.call(this, props) || this;

    _this.unlistenCallback = function () {// if locationListener is not provided by props is just empty function
    };

    return _this;
  }

  Header.prototype.componentDidMount = function () {
    var _this = this;

    if (this.props.locationListener) {
      this.unlistenCallback = this.props.locationListener(function () {
        _this.setState({
          open: false
        });
      });
    }
  };

  Header.prototype.componentWillUnmount = function () {
    this.unlistenCallback();
  };

  Header.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        cta = _a.cta,
        logoClick = _a.logoClick,
        profile = _a.profile;
    var b = config_1.block('header');
    var userLogged = profile !== undefined && profile.items.length > 0;
    return react_1.default.createElement("div", {
      className: b()
    }, react_1.default.createElement("div", {
      className: b('logo'),
      onClick: logoClick
    }), react_1.default.createElement("div", {
      className: b('menu')
    }, userLogged ? children : null), userLogged && cta && cta.button && react_1.default.createElement("div", {
      className: b('cta')
    }, react_1.default.createElement(Button_1.default, {
      small: true,
      variant: Button_1.ButtonVariant.Active,
      onClick: cta.onClick
    }, cta.button)), userLogged && profile && react_1.default.createElement(Profile_1.default, __assign({
      className: b('profile')
    }, profile)), userLogged && react_1.default.createElement(Burger_1.default, {
      className: b('burger')
    }));
  };

  return Header;
}(react_1.Component);

exports.default = Header;